import api from './api';

export const notificationApi = {
  // 알림 목록 조회
  getNotifications: async () => {
    const response = await api.getAuth('/notifications');
    return response.data;
  },

  // 읽지 않은 알림 수 조회
  getUnreadCount: async () => {
    const response = await api.getAuth('/notifications/unread-count');
    return response.data;
  },

  // 알림 읽음 처리
  markAsRead: async (id) => {
    const response = await api.putAuth(`/notifications/${id}/read`);
    return response.data;
  },

  // 모든 알림 읽음 처리
  markAllAsRead: async () => {
    const response = await api.putAuth('/notifications/read-all');
    return response.data;
  },

  // 알림 삭제
  deleteNotification: async (id) => {
    const response = await api.deleteAuth(`/notifications/${id}`);
    return response.data;
  },
};
